import TextRephraseIcon from '@atlaskit/icon-lab/core/text-rephrase';
import * as React from 'react';

export function SvgTextRephrase() {
  return <TextRephraseIcon label="" testId="ads-refreshed-icon" />;
}
